<template>
  <div>
    <Breadcrumbs :title="title"/>
    <div class="container-fluid">
      <div class="row">
        <div class="card col-md-12">
          <div class="card-header">
            <h4>Profit Simulation Matrix</h4>
          </div>
          <div class="card-body">
          <div class="appointment-table table-responsive">
            <table class="table table-bordernone" v-if="summary.length">
              <thead>
              <tr class="text-center">
                <th></th>
                <th :key="'a'+a" v-for="(a) in [0,1,2,3,4,5,6,7]">
                  <b :style="{color:(best) ? (best.sell_pct===a ? 'green' : '') : 'red'}">SELL {{ a }}%</b>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr :key="'t'+t" v-for="(t) in [0,1,2,3,4,5,6,7]">
                <td class="img-content-box">
                  <div class="shadow-none shadow-showcase p-10">
                  <span class="d-block"><b :style="{color:(best) ? (best.buy_pct===t ? 'green' : '') : 'red'}">BUY {{ t }}%</b></span>
                  </div>
                </td>
                <td class="img-content-box" :key="'s'+s" v-for="(s) in [0,1,2,3,4,5,6,7]">
                  <div :class="{'shadow-none':true, 'shadow-showcase':true, 'p-10':true, 'text-success':(best.buy_pct===t && best.sell_pct===s), 'text-warning':(best_pa.buy_pct===t && best_pa.sell_pct===s), 'text-danger':(worst.buy_pct===t && worst.sell_pct===s)}">
                    <span>Holding : {{ Math.round(summary[t][s].holding_cost) }} ({{ summary[t][s].holding_count }})</span><br>
                    <span>Max : {{ Math.round(summary[t][s].holding_cost_max) }} ({{ summary[t][s].holding_count_max }})</span><br>
                    <span>Sold : {{ Math.round(summary[t][s].sold_return) }} ({{ summary[t][s].sold_count }})</span><br>
                    <span>Profit : {{ Math.round(summary[t][s].profit) }} <b :style="{'color':summary[t][s].profit/summary[t][s].amount>0 ? (summary[t][s].profit/summary[t][s].amount>0.2 ? 'green' : 'orange') : 'red'}">{{ Math.round(summary[t][s].profit/summary[t][s].amount*100*10)/10 }}%</b></span><br>
                    <span>Profit PA : <b>{{ Math.round(summary[t][s].profit_annualized_pct) }}%</b> ({{ summary[t][s].holding_days + summary[t][s].sold_days }})</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            </div>
            </div>
        </div>
      </div>

      <div class="row">
        <div class="card col-md-12">
            <highcharts class="chartWrapper" :constructor-type="'stockChart'" :options="charts"></highcharts>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card" :key="'d'+i" v-for="(d,i) in [0,1,2,3,4,5,6,7]">
            <div class="card-header">
              <h4>High Low {{ d }} %</h4>
            </div>
            <div class="card-body">
              <div class="appointment-table table-responsive">
                <table class="table table-bordernone">
                  <thead>
                  <tr>
                    <th>DATE</th>
                    <th>ORDER</th>
                    <th>HOLDING</th>
                    <th>SOLD</th>
                    <th>PROFIT</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :data="tr" :key="i" v-for="(tr, i) in sim">
                    <td class="img-content-box">
                      <span class="font-roboto">{{ tr.date }}</span>
                      <span class="d-block">Open {{ tr.open }}</span>
                      <span class="d-block">High {{ tr.high }}</span>
                      <span class="d-block">Low {{ tr.low }}</span>
                      <span class="d-block">Close {{ tr.close }}</span>
                    </td>
                    <td>
                      <!--                  <span class="font-roboto">Buy</span>-->
                      <div class="shadow-sm shadow-showcase p-10">
                        Buy : {{ Math.round(tr.buy[d][d].buy_price*1000)/1000 }}<br>
                        Unit : {{ tr.buy[d][d].buy_unit }}<br>
                        Amount : {{ Math.round(tr.buy[d][d].buy_cost*100)/100 }}<br>
                        Sell : {{ Math.round(tr.buy[d][d].sell_price*1000)/1000 }}
                      </div>
                    </td>
                    <td>
                      <!--                  <span class="font-roboto">Asset</span>-->
                      <div class="shadow-sm shadow-showcase p-10" :key="'a'+i" v-for="(a,i) in tr.holding[d][d]">
                        Date : {{ a.date }}<br>
                        Buy : {{ Math.round(a.buy_price*1000)/1000 }}<br>
                        Unit : {{ a.buy_unit }}<br>
                        Amount : {{ Math.round(a.buy_cost*100)/100 }}<br>
                        Sell : {{ Math.round(a.sell_price*1000)/1000 }}
                      </div>
                    </td>
                    <td>
                      <!--                  <span class="font-roboto">Sell</span>-->
                      <div class="shadow-sm shadow-showcase p-10" :key="'s'+i" v-for="(s,i) in tr.completed[d][d]">
                        Date : {{ s.date }} -> {{ s.sell_date }} ({{ Math.round(($moment(s.sell_date,'YYYY-MM-DD').unix() - $moment(s.date,'YYYY-MM-DD').unix())/86400) }})<br>
                        Price : {{ Math.round(s.buy_price*1000)/1000 }} -> {{ Math.round(s.sell_price*1000)/1000 }} (+{{ Math.round((s.sell_price/s.buy_price*100-100)*10)/10 }}%)<br>
                        Unit : {{ s.buy_unit }}<br>
                        Profit : {{ Math.round(s.buy_cost*100)/100 }} -> {{ Math.round(s.sell_price*s.buy_unit*100)/100 }} (+{{ Math.round(s.sell_price*s.buy_unit*100)/100-Math.round(s.buy_cost*100)/100 }})
                      </div>
                    </td>
                    <td class="text-center">
                      {{ tr.completed[d][d].length }}<br>
                      {{ tr.completed[d][d].reduce((a,b) => a + Math.round(b.sell_price*b.buy_unit*100)/100 - Math.round(b.buy_cost*100)/100, 0) }}<br>
                      <b :style="{'color':Math.round(tr.completed[d][d].reduce((a,b) => a + Math.round(b.sell_price*b.buy_unit*100)/100 - Math.round(b.buy_cost*100)/100, 0)/3000*100)>0 ? (Math.round(tr.completed[d][d].reduce((a,b) => a + Math.round(b.sell_price*b.buy_unit*100)/100 - Math.round(b.buy_cost*100)/100, 0)/3000*100)>15 ? 'green' : 'orange') : 'red'}">{{ Math.round(tr.completed[d][d].reduce((a,b) => a + Math.round(b.sell_price*b.buy_unit*100)/100 - Math.round(b.buy_cost*100)/100, 0)/3000*100) }}%</b><br>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
export default {
  data: function () {
    return {
      ticker:this.$route.params.ticker,
      start_date:this.$route.params.start_date,
      end_date:this.$route.params.end_date || this.$moment(this.$route.params.start_date).endOf('month').format('YYYY-MM-DD'),
      fromdate: moment().subtract(30,'days').format('YYYY-MM-DD'),
      stock: null,
      charts: {
        chart: {
          zoomType: 'x',
          height: 500
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        navigator: {
          enabled: false
        },
        yAxis: [{
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'OHLC'
          },
          height: '60%',
          lineWidth: 2,
          resize: {
            enabled: true
          }
        }, {
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'Volume'
          },
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 2
        }],
        tooltip: {
          split: true
        },
        credits: { enabled: false },
        series: [{
          type: 'candlestick',
          name: '',
          id: '',
          data: []
        }, {
          type: 'column',
          name: 'Volume',
          data: [],
          yAxis: 1
        }]
      },
      sim: [],
      summary: [],
      best: {},
      best_pa: {},
      worst: {}
    }
  },
  computed: {
    title: function () {
      return (this.stock ? this.stock.name+' - ' : '') + 'High Low Simulator ' + ' - '+this.start_date
    },
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchHLSim()
    },
    fetchHLSim() {
      this.$http.get(`/api/stock/simulate/hl/`+this.ticker+'/'+this.start_date+'/'+this.end_date)
          .then(({data}) => {
            this.sim = data.sim
            this.stock = data.stock
            this.summary = data.summary
            this.best = data.best
            this.best_pa = data.best_pa
            this.fetchChart(this.stock.id, this.stock.id+' '+this.stock.name, this.best)
          })
          .catch(e => {
            console.log(e.message)
            this.$swal.fire({ text:e.message, icon:'error' })
          })
    },
    fetchChart(id, title, best) {
      let url = `/api/stock/chart/`+id+`?year=`+moment(this.start_date).format('YYYY')+'&month='+moment(this.start_date).format('M')+'&title='+title+'&height='+this.charts.chart.height
      if(best.profit) {
        url += '&buy_pct='+this.best.buy_pct + '&sell_pct='+this.best.sell_pct + '&amount='+this.best.amount
      }
      this.$http.get(url)
          .then(({data}) => this.charts = data.chart)
    },
    moment(date) {
      return moment(date)
    }
  }
}
</script>